// Function to call an external API using an ID token
// const fetchCustomData = async (idToken: string) => {
//     try {
//         const response = await axios.get('https://europe-west1-seismic-relic-390308.cloudfunctions.net/helloWorld', {
//             headers: { Authorization: `Bearer ${idToken}` },
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching custom data:", error);
//         throw new Error('Failed to fetch data.');
//     }
// };

import {
    signInWithEmailAndPassword,
    signOut,
    createUserWithEmailAndPassword,
    updateProfile,
    GoogleAuthProvider,
    signInWithPopup,
} from "firebase/auth";
import axios from "axios";
import { auth } from "../firebase";
import { AuthProvider } from "react-admin";

// const createTenantAndUser = async (displayName: string, email: string, password: string) => {
//     try {
//         console.log("Sending request with data:", { displayName, email, password }); // Log the request data
//         const response = await axios.post(
//             'https://europe-west1-seismic-relic-390308.cloudfunctions.net/TenantTest',
//             { displayName, email, password }
//         );
//         return response.data; // Expecting tenantId and tenantName in the response
//     } catch (error) {
//         if (error instanceof Error) {
//             console.error("Error creating tenant and user:", error.message);
//         } else {
//             console.error("An unknown error occurred:", error);
//         }
//         throw new Error('Failed to create tenant and user.');
//     }
// };

const authProvider: AuthProvider = {
    login: async ({ email, password }) => {
        try {
            // Firebase login
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            console.log("User signed in:", user);

            // Fetch tenantId from backend or from user custom claims
            const idTokenResult = await user.getIdTokenResult();
            const tenantId = idTokenResult.claims.tenantId || null;

            if (!tenantId) {
                throw new Error("No tenant ID associated with user.");
            }

            const authInfo = {
                uid: user.uid,
                email: user.email,
                tenantId,
            };
            return authInfo;
        } catch (error) {
            console.error("Login error:", error);
            throw new Error("Invalid login credentials.");
        }
    },

    // register: async ({ email, password, displayName }: { email: string; password: string; displayName: string }) => {
    //     try {
    //         // Register the user with Firebase
    //         const tenantData = await createTenantAndUser(displayName, email, password);
    //         auth.tenantId = tenantData.tenantId;
    //         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    //         const user = userCredential.user;

    //         console.log("User registered:", user);

    //         // Update the user's display name, if provided
    //         if (displayName) {
    //             await updateProfile(user, { displayName });
    //         }

    //         // Call backend API to create a tenant and user

    //         return {
    //             uid: user.uid,
    //             email: user.email,
    //             tenantId: tenantData.tenantId, // Use tenantId from backend response
    //         };
    //     } catch (error) {
    //         console.error("Registration error:", error);
    //         throw new Error("Failed to register user.");
    //     }
    // },

    googleLogin: async () => {
        try {
          const provider = new GoogleAuthProvider();
          const result = await signInWithPopup(auth, provider);
          const user = result.user;
      
          console.log("Google user logged in:", user);
      
          const idToken = await user.getIdToken();
      
          // Send the idToken to the backend
          const response = await axios.post("https://europe-west1-seismic-relic-390308.cloudfunctions.net/Google-Login", {
            idToken,
          });
      
          const { email, tenantID, tenantName } = response.data.user;
      
          return {
            uid: user.uid,
            email,
            displayName: user.displayName,
            tenantID,
            tenantName,
          };
        } catch (error) {
          console.error("Google Login error:", error);
          throw new Error("Google login failed.");
        }
      },
      

    logout: async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Logout error:", error);
            throw new Error("Failed to log out.");
        }
    },

    checkError: (error: any) => {
        console.error("Error during request:", error);
        return Promise.reject(error);
    },

    checkAuth: async () => {
        const user = auth.currentUser;
        if (!user) return Promise.reject();

        const idTokenResult = await user.getIdTokenResult();
        if (!idTokenResult.claims.tenantId) {
            console.error("No tenant ID associated with user.");
            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: async () => {
        const user = auth.currentUser;
        if (!user) return null;

        // Replace with actual permission logic
        return ['read', 'write', 'manage'];
    },
};

export default authProvider;
